import React from 'react';
import { connect } from 'react-redux';
import {setTabs} from '../../actions/feed';
import LoginForm from '../modal/login.jsx';

class Login extends React.Component {

  constructor(props) {
    super(props);
    this.state = {}

  }

    isMobile(){
      return window.innerWidth<800
    }

    render () {

      const user = this.props.user
      let mobile = this.isMobile()
      if(user && user.feeds){
          const userFeeds = user.feeds

          if(userFeeds[0] && !userFeeds[0].type){
            userFeeds[0].type = 'home'
          }
          this.props.setTabs(userFeeds, user);
      }


      return (
            <div style={{
              position: 'absolute',
              left: 0,
              top: 0,
              bottom: 0,
              right: 0,
              zIndex: 1000,
              background: 'linear-gradient(-20deg, #e9defa 0%, #fbfcdb 100%)',
              backgroundSize: 'cover',
              overflow:'hidden scroll'
            }} >
              <LoginForm redirect={this.props.redirect} style={{fontSize: 'initial', fontWeight: 'initial', color: 'initial',zIndex: 100}}/>

        </div>
        );
    }

}

const mapStateToProps = (state)=>{
  return {
    user:state.auth.user,
    selectedPuff: state.puff.selectedPuff.puff
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setTabs:(feeds, user)=>dispatch(setTabs(feeds, user)),
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(Login)
